/*
 * @Descripttion:
 * @Author: Niu Chenxin
 * @Date: 2020-11-27 17:14:03
 * @LastEditors: Niu Chenxin
 * @LastEditTime: 2020-11-30 17:01:28
 */
import {
  is_weixin
} from '@/assets/js/common.js'
import wx from 'weixin-js-sdk'

export default {
  wxShare: function (shareDataParams, obj) {
    var that = this;
    if (is_weixin()) {
      obj.$http.get('/wechat/oauth2/getJSSDKConfig?url=' + encodeURIComponent(location.href.split('#')[0]), {}, res => {
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          openTagList: ["wx-open-launch-weapp"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline', // 分享到朋友圈接口
            'onMenuShareAppMessage', //  分享到朋友接口
            'updateAppMessageShareData',
            'updateTimelineShareData'
          ]
        });
        wx.ready(function () {
          // 微信分享的数据
          var shareData = {
            link: shareDataParams.shareLink,
            desc: shareDataParams.shareDesc,
            title: shareDataParams.shareTitle,
            imgUrl: shareDataParams.imgUrl,
            success: function () {
              if (shareDataParams.shareSensorsFn) {
                that.shareSensorsFn();
                obj.$toast({
                  duration: 2000,
                  message: "分享成功",
                  context: this
                })
              }
            }
          }
          wx.onMenuShareTimeline(shareData); //分享到朋友圈
          wx.onMenuShareAppMessage(shareData); //分享给朋友
          wx.updateAppMessageShareData(shareData); //分享给朋友和分享到QQ
          wx.updateTimelineShareData(shareData); //分享到朋友圈和分享到QQ空间
        })
      })
    }
  },
  shareSensorsFn() {
    sensors.track('ClickShare'); // 分享点击次数
  }
}